export default __webpack_public_path__ + "media/images/phone-icon-e924af5651ccfa501ee6a827860d2d5a.svg";